<template>
  <section class="py-12">
    <div class="container-wrap">
      <p class="text-sm font-bold text-gray-600">
        {{ tGlobal('products.section-name.capabilities') }}
      </p>
      <h2 class="text-h2 mb-6">
        {{ productCapabilities.sectionTitle }}
      </h2>

      <!-- Tabs -->
      <TheTabSelector
        v-model="currentIndex"
        :tabs="productCapabilityItems.map((item) => item.briefTabName)"
      />

      <!-- Selected item -->
      <CapabilitiesCard v-if="currentItem" :item-data="currentItem" />
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { IProductInfoCapabilityItem } from '@/assets/types/api/Products';
  import CapabilitiesCard from '@/components/Area/Products/CapabilitiesCard.vue';

  const { t: tGlobal } = useI18n({ useScope: 'global' });

  const productsStore = useProductsStore();
  const { productCapabilities, productCapabilityItems } =
    storeToRefs(productsStore);

  const currentIndex = ref<number>(0);

  const currentItem = computed((): IProductInfoCapabilityItem | null => {
    return productCapabilityItems.value[currentIndex.value] ?? null;
  });
</script>
